import {useEffect, useState} from 'react';
import {getQuaterListDetails} from '../services/quaterdetails';

const useQuaterListHook = (quaterWiseDataList=[]) => {
  const [currentQuater, setCurrentQuater] = useState<any>();
  const [quaterListData, setQuaterListData] = useState<any>([]);
  useEffect(() => {
    const quaterDetails = async () => {
      const response: any = await getQuaterListDetails();
      setCurrentQuater(response?.data?.currentQuarter);
      const {currentQuarter, nextQuarter, secondNextQuarter, thirdNextQuarter, fourthNextQuarter,fifthNextQuarter,sixthNextQuarter
      } =
        response?.data;
      const arr = [
        currentQuarter,
        nextQuarter,
        secondNextQuarter,
        thirdNextQuarter,
        fourthNextQuarter,
        fifthNextQuarter,
        sixthNextQuarter
      ];
      setQuaterListData(arr || []);
    };
    quaterDetails();
  }, []);
  const getQuaterStartData = (tag: string,next_tag?:any) => {
    let next_quarter:any;
    let next_year:any
    if(next_tag){
      if(next_tag.includes("-")){
        next_quarter=next_tag.split('-')[0]
        next_year=next_tag.split('-')[1]
      return quaterListData?.filter((res: any) => {
        return res?.quarter === next_quarter && res?.year===next_year;
      })[0];
      }else{
        return quaterListData?.filter((res: any) => {
          return res?.quarter === tag && res?.year===next_tag;
        })[0]
      }
     
    }
    if(tag && !next_tag){
      if(quaterWiseDataList.length && tag){
        return quaterWiseDataList?.filter((res: any) => {
          return res?.quarter === tag  ;
        })[0];
      }else{
        return quaterListData?.filter((res: any) => {
          return res?.quarter === tag ;
        })[0];
      }
    }
  };
  return {
    currentQuater: currentQuater?.quarter,
    quaterListData,
    getQuaterStartData,
  };
};

export default useQuaterListHook;
